<template>
    <v-container class="page-success" fluid fill-height :style="'width: ' + width">
            <v-flex>
                <v-card class="elevation-0 pa-5">
                    <v-card-text>
                        <div class="d-flex justify-center align-center">
                            <v-icon x-large>mdi-check-bold</v-icon>
                            <div class="text-h5 mt-1 ml-4"> {{title}}</div>
                        </div>
                        <br v-if="message">
                        <p class="mt-5 mb-5" v-if="message" v-html="message"></p>
                    </v-card-text>
                    <v-card-actions>
                        <slot name="actions"></slot>
                    </v-card-actions>
                </v-card>
            </v-flex>
    </v-container>
</template>

<script>
export default {
    name: "PageSuccess",
    props: ['title', 'message', 'width']
}
</script>

